module.exports = __webpack_public_path__ + "img/face.4473ee47.png";